import React from "react";
import { useParams } from "react-router";

import { Breadcrumbs } from "../../components/Breadcrumbs";
import { UserDetails } from "../../components/UserDetails";
import { UserMembership } from "../../components/UserMembership";
import { UserTabs } from "../../components/UserTabs";
import { UserProvider, useUserContext } from "../../contexts/UserContext";
import { MainLayout } from "../../layout/MainLayout";
import { Grid } from "../../UI/Grid";
import { Paper } from "../../UI/Paper";

const UserPageContent = () => {
  const { user } = useUserContext();

  React.useEffect(() => {
    if (user?.firstName && user?.lastName) {
      document.title = `RoomSync Admin - ${user.firstName} ${user.lastName}`;
    }

    return () => {
      document.title = "RoomSync Admin";
    };
  }, [user?.firstName, user?.lastName]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs />
      </Grid>
      <Grid item xs={12}>
        <UserDetails />
      </Grid>
      <Paper sx={{ p: 3, pt: 0, mb: "20px", mt: "20px", ml: "12px", width: "100%"}}>
        <Grid item xs={12} mt={5}>
          <UserMembership />
        </Grid>
        <Grid item xs={12} mx={-1}>
          <UserTabs />
        </Grid>
      </Paper>
    </Grid>
  );
};

export const UserPage = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <MainLayout>
      <UserProvider userId={id}>
        <UserPageContent />
      </UserProvider>
    </MainLayout>
  );
};
